import { createSlice } from '@reduxjs/toolkit';
import type { ProviderCommonHeaderState } from './types';
import {
  addToFavoriteList,
  deleteFromFavoriteList,
  fetchFavoriteListStatus,
  fetchHeaderInfo,
} from './actions';

const initialState: ProviderCommonHeaderState = {
  data: null,
  rtCond: {},
  rtCondEx: {
    dated: false,
    dayuse: false,
  },
  isBookmarked: false,
  isBookmarkStatusFetched: false,
  isBookmarkError: false,
  isBookmarkLimitError: false,
  bookmarkErrorId: '',
  isFetching: false,
  isJRDP: false,
  jrdpQuery: '',
};

const providerCommonHeaderSlice = createSlice({
  name: 'providerCommonHeader',
  initialState,
  reducers: {
    setIsJRDP(state, action) {
      state.isJRDP = action.payload;
    },
    setJrdpQuery(state, action) {
      state.jrdpQuery = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHeaderInfo.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchHeaderInfo.fulfilled, (state, action) => {
        const { data, rtCond, rtCondEx } = action.payload;

        state.data = data;
        state.rtCond = rtCond;
        state.rtCondEx = rtCondEx;
        state.isFetching = false;
      })
      .addCase(fetchHeaderInfo.rejected, (state) => {
        state.isFetching = false;
      })
      .addCase(fetchFavoriteListStatus.fulfilled, (state, action) => {
        const data = action.payload[0]?.bookmarked ?? false;

        state.isBookmarked = data;
        state.isBookmarkStatusFetched = true;
      })
      .addCase(fetchFavoriteListStatus.rejected, (state) => {
        state.isBookmarkStatusFetched = true;
      })
      .addCase(addToFavoriteList.fulfilled, (state) => {
        state.isBookmarked = true;
        state.isBookmarkError = false;
        state.bookmarkErrorId = '';
      })
      .addCase(addToFavoriteList.rejected, (state, action) => {
        state.bookmarkErrorId = Date.now().toString();

        if ((action.payload as { status: number }).status === 403) {
          state.isBookmarkLimitError = true;
        }

        state.isBookmarkError = true;
      })
      .addCase(deleteFromFavoriteList.fulfilled, (state) => {
        state.isBookmarked = false;
        state.isBookmarkError = false;
        state.bookmarkErrorId = '';
      })
      .addCase(deleteFromFavoriteList.rejected, (state, _action) => {
        state.bookmarkErrorId = Date.now().toString();
        state.isBookmarkError = true;
      });
  },
});

export const { setIsJRDP, setJrdpQuery } = providerCommonHeaderSlice.actions;

export const providerCommonHeaderReducer = providerCommonHeaderSlice.reducer;
